import clsx from 'clsx';
import { useCallback, useContext, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';

import { Modal, ModalSizing } from '@vestico/shared';

import { WidgetRootElementContext } from '../../../components/MainWindow';
import { MatchingTypeProps } from '../../../model/matchingType';
import { SizeRecommendationDetails } from '../../matching/SizeRecommendationDetails';
import style from './CarouselMobile+SizeRec.module.css';

export const CarouselMobileSizeRecModal = ({
  sizeRecommendation,
  activeMatchingType,
  onActiveMatchingTypeChange,
  hasContentMatchAvailable,
  hasSizeRecAvailable,
  defaultMatchingType,
}: MatchingTypeProps) => {
  const rootElement = useContext(WidgetRootElementContext);

  const [didCloseSizeRec, setDidCloseSizeRec] = useState(false);
  const onSizeRecModalClose = useCallback(() => {
    onActiveMatchingTypeChange('content');
    setDidCloseSizeRec(true);
  }, [onActiveMatchingTypeChange]);

  const sizeRecModal = useMemo(() => {
    if (hasSizeRecAvailable) {
      const showFullModal = defaultMatchingType === 'size-rec' && !didCloseSizeRec;
      return (
        <Modal
          open={activeMatchingType === 'size-rec'}
          sizing={showFullModal ? ModalSizing.full : ModalSizing.intrinsicHeight}
          alignment={showFullModal ? 'center' : 'bottom'}
          showClose
          onClose={onSizeRecModalClose}
          noAnimateAppear={showFullModal}
        >
          <div className={clsx(style.root)}>
            <SizeRecommendationDetails
              sizeRecommendation={sizeRecommendation}
              sizeChart={sizeRecommendation?.chart}
              showContentToggle={hasContentMatchAvailable}
              onContentToggle={onSizeRecModalClose}
            />
          </div>
        </Modal>
      );
    }
    return null;
  }, [
    activeMatchingType,
    defaultMatchingType,
    didCloseSizeRec,
    hasContentMatchAvailable,
    hasSizeRecAvailable,
    onSizeRecModalClose,
    sizeRecommendation,
  ]);

  return sizeRecModal ? createPortal(sizeRecModal, rootElement ?? document.body) : null;
};
